// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';
import configs from '../configs';
import { IntegrationLayout, OAuthSetup, ExternalLinkA } from '../_shared';

class Fanbridge extends Component {
  componentDidMount() {
    this.props.store.integrations.Fanbridge.getConfigs();
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) this.props.store.integrations.Fanbridge.getTokens(code);
  }

  render() {
    return (
      <IntegrationLayout config={configs.Fanbridge}>
        <OAuthSetup
          partnerKey="Fanbridge"
          steps={[
            <>Create a Fanbridge account <ExternalLinkA href="https://www.fanbridge.com/plan/?src=login_signup_link&utm=movology">here</ExternalLinkA> if you don&apos;t have one already.</>,
            'Grant Movology the necessary permissions:',
            'After authorizing, future captures will be added as Fanbridge contacts.',
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(Fanbridge)));
